export const layout = {
    container:
        'max-w-maxWContainerM lg:max-w-maxWContainerD mx-auto px-[16px] lg:px-[15px]',
    containerP:
        'max-w-maxWContainerM lg:max-w-maxWPaywallContainerD xl:max-w-full mx-auto px-[16px] lg:px-[15px]',
    separator: 'h-[1px] w-full bg-loader',
};

export const textNodes = {
    h1: 'font-sans font-extrabold text-[32px] leading-[38px] text-center',
    h2: 'font-extrabold text-[26px] leading-[34px] text-center',
    h3: 'font-extrabold text-[24px] leading-[29px]',
    h4: 'font-extrabold text-[18px] leading-[22px]',
    button: 'font-black text-[20px] leading-[27px]',
    p: 'font-normal text-[18px] leading-[25px]',
    smallP: 'font-medium text-[14px] leading-[19px]',
    listItem: 'font-normal text-[16px] leading-[22px]',
    little: 'font-normal text-[12px] leading-[16px]',
};

export const inputs = {
    default:
        'w-full h-[50px] rounded-lg px-4 text-[#002E38] border border-[#ADBDC6] bg-white focus:outline-none focus:border-[#00A1C6] focus:border-[#00A1C6] transition-all duration-200',
};

export {};
